<template>
  <Layout>
    <PageHeader :title="'Hesap Ekstresi'" :items="breadcrumbArray"></PageHeader>
    <v-app>
      <div class="row">
        <div class="col-lg-12">
          <Results></Results>
        </div>
      </div>
    </v-app>

  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import Results from "@/components/my-account/account-statements/Results.vue"
export default {
  page: {
    title: "Hesap Ekstresi",
    meta: [{ name: "description", content: "Hesap Ekstresi" }],
  },
  components: {
    Layout,
    PageHeader,
    Results
  },
  computed: {
  },
  data() {

    return {
      breadcrumbArray: [
        {
          text: "Hesabım",
          active: false,
        },
        {
          text: "Hesap Ekstresi",
          active: true,
        },
      ],

    };
  },
  methods: {

  },
};
</script>